export const MODULE_PREFIX = 'documents';

export enum ActionTags {
    ACCEPT_DECLINE = '{AcceptDecline}',
    ACCEPT = '{Accept}',
}

export enum GeneralTags {
    PAGE_BREAK = '{PageBreak}',
}

export enum SectionInputTypes {
    AcceptDecline = 'AcceptDecline',
    Accept = 'Accept',
}

export enum SectionInputValues {
    Accepted = 'Accepted',
    Declined = 'Declined',
}

export const TagToSectionInputTypeMapping = {
    [ActionTags.ACCEPT_DECLINE]: SectionInputTypes.AcceptDecline,
    [ActionTags.ACCEPT]: SectionInputTypes.Accept,
};
